import { lazy } from "react";
import Loadable from "components/Loadable";
import { routeConstants, FormatConstants } from "services/keyConstants";
import * as url from "./urlHelpers";
import { getDynamicStatusTypes } from "./service";
import {
  workEnvironmentDownload,
  workEnvironmentList,
} from "api/module/workEnvironment";

// Lazy-loaded components
const Area = Loadable(lazy(() => import("../Area")));
const DetailList = Loadable(lazy(() => import("../DetailList")));
const PestControl = Loadable(lazy(() => import("../PestControl")));
const EsdControl = Loadable(lazy(() => import("../EsdControl")));
const ApproneAndSlipperCleaningRecord = Loadable(
  lazy(() => import("../ApproneAndSlipperCleaningRecord"))
);
const TemperatureAndHumidityMonitoringRecord = Loadable(
  lazy(() => import("../TemperatureAndHumidityMonitoringRecord"))
);
const FumigationRecord = Loadable(lazy(() => import("../FumigationRecord")));
const PersonnelHygiene = Loadable(lazy(() => import("../PersonnelHygiene")));
const CleaningRegister = Loadable(lazy(() => import("../CleaningRegister")));
const CommonDetail = Loadable(
  lazy(() => import("components/CommonDetail/CommonDetail"))
);

// API handler
const handleDynamicApiCall = async (masterDocData) => {
  try {
    const result = await Promise.all([
      getDynamicStatusTypes(masterDocData?.defaultName),
    ]);
    return result;
  } catch (error) {
    console.error("Error in dynamic API call:", error);
    return {};
  }
};

const WERoutes = [
  {
    path: routeConstants.WORK_ENVIRONMENT,
    children: [
      {
        path: "detail/:id",
        element: (
          <CommonDetail
            navigateRoute={{
              isCondition: false,
              url: (item, filterData, masterDocData) => {
                const routeMap = {
                  [FormatConstants.WORKENVIRONMENT.CLEANING_REGISTER]:
                    "cleaning-register",
                  [FormatConstants.WORKENVIRONMENT.PERSONAL_HYGIENE_RECORD]:
                    "personnel-hygiene-record",
                  [FormatConstants.WORKENVIRONMENT
                    .TEMPERATURE_HUMIDITY_REGISTER]:
                    "temperature-and-humidity-monitoring-record",
                  [FormatConstants.WORKENVIRONMENT
                    .APRON_SLIPPER_CLEANING_RECORD]:
                    "appron-and-slipper-cleaning-record",
                  [FormatConstants.WORKENVIRONMENT.FUMIGATION_RECORD]:
                    "fumigation-record",
                  [FormatConstants.WORKENVIRONMENT.ESD_CONTROL_LOG]:
                    "esd-control",
                  [FormatConstants.WORKENVIRONMENT.PEST_CONTROL_RECORD]:
                    "pest-control",
                };
                const dynamicRoute =
                  routeMap[masterDocData?.defaultName] ?? "-";
                return `/${routeConstants.WORK_ENVIRONMENT}/${dynamicRoute}/${item?._id}`;
              },
            }}
            url={{
              GET: workEnvironmentList,
              DOWNLOAD: workEnvironmentDownload,
            }}
            handleDynamicApiCall={handleDynamicApiCall}
            isDynamicFilters={true}
            filterOptions={{
              [FormatConstants.WORKENVIRONMENT.CLEANING_REGISTER]: [
                { name: "Area", optionsKey: "areaOptions" },
              ],
              [FormatConstants.WORKENVIRONMENT.TEMPERATURE_HUMIDITY_REGISTER]: [
                { name: "Area", optionsKey: "areaOptions" },
              ],
              [FormatConstants.WORKENVIRONMENT.FUMIGATION_RECORD]: [
                { name: "Area", optionsKey: "areaOptions" },
              ],
              [FormatConstants.WORKENVIRONMENT.PERSONAL_HYGIENE_RECORD]: [
                { name: "Area", optionsKey: "areaOptions" },
              ],
              [FormatConstants.WORKENVIRONMENT.APRON_SLIPPER_CLEANING_RECORD]: [
                { name: "Area", optionsKey: "areaOptions" },
              ],
              [FormatConstants.WORKENVIRONMENT.PEST_CONTROL_RECORD]: [
                { name: "Area", optionsKey: "areaOptions" },
              ],
              [FormatConstants.WORKENVIRONMENT.ESD_CONTROL_LOG]: [
                { name: "Area", optionsKey: "areaOptions" },
              ],
            }}
            buttonsData={(masterDocData) => [
              { name: "Area", route: `../area` },
              {
                name: "Create",
                route: `../manage/${masterDocData?.masterDocId}`,
              },
            ]}
            tableConfig={{
              chip: {
                status: (data) => {
                  const color =
                    {
                      Initialized: "info",
                      "Not Initialized":"error",
                      "In Review": "warning",
                      Approved: "success",
                    }[data?.row?.status] || "default";
                  return {
                    label: data?.row?.status,
                    color,
                  };
                },
              },
            }}
          />
        ),
      },
      { path: "area", element: <Area /> },
      { path: "manage/:masterDocId", element: <DetailList /> },
      { path: "pest-control/:id?", element: <PestControl /> },
      { path: "esd-control/:id?", element: <EsdControl /> },
      { path: "fumigation-record/:id?", element: <FumigationRecord /> },
      {
        path: "appron-and-slipper-cleaning-record/:id?",
        element: <ApproneAndSlipperCleaningRecord />,
      },
      {
        path: "temperature-and-humidity-monitoring-record/:id?",
        element: <TemperatureAndHumidityMonitoringRecord />,
      },
      { path: "cleaning-register/:id?", element: <CleaningRegister /> },
      { path: "personnel-hygiene-record/:id?", element: <PersonnelHygiene /> },
    ],
  },
];

export default WERoutes;
